import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';

class ConditionSnomedICD extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, codes } = this.props;

    return (
      <div className={`condition-snomed-icd ${className}`}>
        <table>
          <thead>
            <tr>
              <th>Sub-Condition Name</th>
              <th>ICD</th>
              <th>SNOMED</th>
            </tr>
          </thead>

          <tbody>
            {sortBy(codes, 'conditionName').map((subCondition) => (
              <tr key={subCondition.conditionName}>
                <td>{subCondition.conditionName}</td>
                <td className="condition-snomed-icd__icd">
                  {(subCondition.icd || []).map((icd, index) => (
                    <span key={index}>{icd}</span>
                  ))}
                </td>
                <td className="condition-snomed-icd__snomed">
                  {(subCondition.snomed || []).map((snomed, index) => (
                    <span key={index}>{snomed}</span>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

ConditionSnomedICD.defaultProps = {
  className: '',
  codes: []
};

ConditionSnomedICD.propTypes = {
  className: PropTypes.string,
  codes: PropTypes.array
};

export default ConditionSnomedICD;
